import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import ab from '../assets/images/tour-operator-software-head.jpg';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const Tour = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<div
				style={{
					backgroundImage: `url(${ab})`,
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					Tour Operator Software
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					Tour Operator Software
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					Tour and Travel Website Development
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/tour-operator.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								A Tour operator software is not only an online booking engine in
								which customers can search and book tours according to their
								preference but also Tour Operator can manage itineraries, add
								itineraries, manage bookings etc. Tour booking system helps in
								automating tour booking process, selling the packages through
								web portal and to enhance online travel business and increase
								customer base. musafir offers most high-grade tour operator &
								Travel Booking Software solutions to global travel agencies,
								Destination Management Company, Online Travel Agency portals,
								International Air Transport Association agents and tour
								operators.
							</p>
							<br />
							<p>
								Arya Aviation provides the advanced technology-based holiday
								management software for Travel Agencies that help travellers to
								book a holiday package as per their sightseeing preferences and
								making itinerary with the help of customisation features
								available on web page. Tour and Travel Agency can add and manage
								package inventory, group travel, manage customers & travel
								agents, fully automate your sales process, query follow up
								management etc. with the help of Travel CRM.
							</p>
							<br />
							<p>
								We develop a fully customized tour booking software that allows
								travellers to make easier reservations, modifications and
								cancellations directly from the website. We offer cost-effective
								and practically best in the industry booking engines for Tour
								Operating agencies. Tour booking software offers a smart and
								sleek booking experience and requires the least efforts to book
								the desired holiday package online. Our solution is fully
								cross-platform. Our tour operator software allows the tour
								operating agencies to combine various holiday resources like
								Flights/ Hotels/ Bus&Cars bookings/ with the package. Customer
								can make packages for groups looking for casual tour or office
								employees tour package in the same system. Using our tour
								booking engine software Online Travel Agents can provide
								multiple options to their guests who can choose from a wide
								range of available packages as per their needs. You can also
								improve customer relationship with email / SMS based automated
								follow up system.
							</p>
							<br />
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default Tour;
